module.exports = __webpack_public_path__ + "static/img/sucess.f5fc2419.png";